const pricingData = [
    {
        id: 1,
        price: "250",
        about: [
            "1 DSA Mock Interview",
            "Company Specific",
            "45 Mins"
        ]
    },
    {
        id: 2,
        price: "600",
        about: [
            "3 DSA Mock Interview",
            "Company Specific",
            "45 Mins each"
        ]
    },
    {
        id: 3,
        price: "200",
        about: [
            "1 HR Mock Interview",
            "Company Specific",
            "45 Mins"
        ]
    },
    {
        id: 4,
        price: "350",
        about: [
            "1 DSA + 1 HR Mock Interview",
            "Company Specific",
            "45 Mins each"
        ]
    },
    {
        id: 5,
        price: "500",
        about: [
            "2 DSA + 1 HR Mock Interview",
            "Company Specific",
            "45 Mins each"
        ]
    },
    {
        id: 6,
        price: "700",
        about: [
            "3 DSA Mock Interview (Difficult)",
            "Company Specific",
            "45 Mins each"
        ]
    },
];

export default pricingData;